import { render, staticRenderFns } from "./DEditorConfirmPopup.vue?vue&type=template&id=b5126ed2&scoped=true&"
import script from "./DEditorConfirmPopup.vue?vue&type=script&lang=js&"
export * from "./DEditorConfirmPopup.vue?vue&type=script&lang=js&"
import style0 from "./DEditorConfirmPopup.vue?vue&type=style&index=0&id=b5126ed2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5126ed2",
  null
  
)

export default component.exports